import { ITressTheCheckoutViewModel } from "@/models/ITressTheCheckoutViewModel";
import { defineStore } from "pinia";

export const useCheckout = defineStore("checkout", {
  state: (): ITressTheCheckoutViewModel => {
    return {
      comment: "",
      deliveryMethodId: "",
      paymentMethodId: "",
      shippingPostalCode: "",
      servicePointId: "",
      customerType: "",
    };
  },
  actions: {
    async set(checkout: ITressTheCheckoutViewModel): Promise<void> {
      this.$patch({ ...checkout });
    },
    async setDeliveryMethodId(deliveryMethodId: string): Promise<void> {
      this.$patch({ deliveryMethodId });
    },
    async clearDeliveryMethod(): Promise<void> {
      this.$patch({ deliveryMethodId: "", servicePointId: "" });
    },
    async setShippingPostalCode(shippingPostalCode: string): Promise<void> {
      this.$patch({ shippingPostalCode });
    },
    async setServicePointId(servicePointId: string): Promise<void> {
      this.$patch({ servicePointId });
    },
    async setCustomerType(customerType: string): Promise<void> {
      this.$patch({ customerType });
    },
    async reset(): Promise<void> {
      this.$reset();
    },
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: sessionStorage,
      },
    ],
  },
});
